/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Trouble_Logs_AInputs */

const en_wc_dl_trouble_logs_a = /** @type {(inputs: Wc_Dl_Trouble_Logs_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows: %APPDATA%\\WordCraft\\logs\\ · macOS: ~/Library/Application Support/WordCraft/logs/ · Linux: ~/.config/wordcraft/logs/. Attach wordcraft.log when you report a bug on GitHub or Discord.`)
};

/**
* | output |
* | --- |
* | "Windows: %APPDATA%\\WordCraft\\logs\\ · macOS: ~/Library/Application Support/WordCraft/logs/ · Linux: ~/.config/wordcraft/logs/. Attach wordcraft.log when you r..." |
*
* @param {Wc_Dl_Trouble_Logs_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_trouble_logs_a = /** @type {((inputs?: Wc_Dl_Trouble_Logs_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Trouble_Logs_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_trouble_logs_a(inputs)
});
export { wc_dl_trouble_logs_a as "wc.dl.trouble.logs.a" }